class FnkChainStock extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener('variant:update', this.updateStock);
    this.placeAfterTitle();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener('variant:update', this.updateStock);
  }

  updateStock = (event) => {
    const productId = event.detail?.data?.productId;
    if (productId && productId !== this.dataset.productId) {
      return;
    }

    const newStock = event.detail?.data?.html?.querySelector(
      `fnk-chain-stock[data-product-id="${this.dataset.productId}"]`
    );
    if (!newStock) {
      this.hidden = true;
      return;
    }

    this.dataset.productId = newStock.dataset.productId;
    this.innerHTML = newStock.innerHTML;
    this.hidden = newStock.hidden;
    this.placeAfterTitle();
  };

  placeAfterTitle() {
    const productDetails = this.closest('.product-details');
    const title = productDetails?.querySelector('.text-block h1');
    const titleBlock = title?.closest('.text-block');

    if (titleBlock && titleBlock.nextElementSibling !== this) {
      titleBlock.insertAdjacentElement('afterend', this);
    }
  }
}

if (!customElements.get('fnk-chain-stock')) {
  customElements.define('fnk-chain-stock', FnkChainStock);
}
